import axios from 'axios';
import ApiService from "./ApiService";

//Cette classe permet de gerer tous les process d'authentificatioh OAuth 2 (Password Flow)
export default {
    storageKey:"oauth-token",
    userKey:"oauth-user",

    //Retour True si l'utilisateur est authentifié
    isAuthenticated() {
        return this.getToken() != null;
    },

    //Vérifie si le token doit être rafraichit
    needRefresh(){
        let token = this.getToken();
        let now = new Date().getTime();

        if(this.isAuthenticated() && now >= token.expires_at){
            return true;
        }

        return false;
    },

    //Retourne le token présent dans le storage, null sinon
    getToken(){
        if (localStorage.getItem(this.storageKey)) {
            try {
                return JSON.parse(localStorage.getItem(this.storageKey));
            } catch (e) {
                localStorage.removeItem(this.storageKey);
                return null;
            }
        }

        return null;
    },

    //Retourne l'access token, null sinon
    getAccessToken(){
        let token = this.getToken();

        if (token) {
            return token.access_token;
        }

        return null;
    },


    //Permet de déconnecter l'utilisateur et supprimer les données présentent dans le storage
    signOut(){
        this.setCurrentUser(null);
        localStorage.removeItem(this.storageKey);
    },


    //Process de refesh du token
    refreshToken(){
        let token = this.getToken();
        let promise =  axios.post(process.env.VUE_APP_API_URI + '/oauth/token', {
            grant_type: "refresh_token",
            scope: "SCOPE_USER",
            refresh_token:token.refresh_token,
            client_id: process.env.VUE_APP_API_CLIENTID,
            client_secret: process.env.VUE_APP_API_SECRET
        });

        promise.then(response => {
            response.data.expires_at = (new Date().getTime()) + (response.data.expires_in * 1000);
            localStorage.setItem(this.storageKey,JSON.stringify(response.data));
        });

        return promise;
    },


    //Process de connexion
    signIn(email, password){
        let promise =  axios.post(process.env.VUE_APP_API_URI + '/oauth/token', {
            grant_type: "password",
            scope: "SCOPE_USER",
            username: email,
            password: password,
            client_id: process.env.VUE_APP_API_CLIENTID,
            client_secret: process.env.VUE_APP_API_SECRET
        });

        promise.then(response => {
                response.data.expires_at = (new Date().getTime()) + (response.data.expires_in * 1000);
                localStorage.setItem(this.storageKey,JSON.stringify(response.data));
        });
       return promise;
    },

    //Process de vérification des accés, lance un refresh si besoin
    checkAccess(callback){
        if(this.isAuthenticated()){
            if(this.needRefresh()){
                this.refreshToken().then(() => {
                    callback(true);
                }).catch(() => {
                    callback(false);
                });
            }
            else{
                callback(true);
            }
        }
        else{
            callback(false);
        }
    },


    //Permet de rafraichir les données de l'utilisateur
    reloadUser(){
        let p = ApiService.getProfilApi().get();

        p.then((response)=>{
            this.setCurrentUser(response.data);
        }).catch(()=>{
            this.setCurrentUser(null);
        });

        return p;
    },

    //Sauvegarde les données de l'utilisateru dans le storage
    setCurrentUser(user = null){
        if(user != null){
            localStorage.setItem(this.userKey, JSON.stringify(user));
        }
        else{
            localStorage.removeItem(this.userKey);
        }
    },

    //Permet de récupere les donénes de l'utilisateur présent dans le storage
    getCurrentUser(){
        if (localStorage.getItem(this.userKey)) {
            try {
                return JSON.parse(localStorage.getItem(this.userKey));
            } catch (e) {
                localStorage.removeItem(this.userKey);
                return null;
            }
        }

        return null;
    }
}
